import React, {
  createContext,
  useContext,
  useSyncExternalStore,
} from "react";
import PropTypes from "prop-types";

import {
  assertStudioThemeRuntime,
} from "../../engines/StudioThemeEngine";


const StudioThemeContext = createContext(null);


export function StudioThemeProvider({
  themeRuntime,
  children,
}) {
  const validatedThemeRuntime =
    assertStudioThemeRuntime(themeRuntime);

  return (
    <StudioThemeContext.Provider
      value={validatedThemeRuntime}
    >
      {children}
    </StudioThemeContext.Provider>
  );
}


StudioThemeProvider.propTypes = {
  themeRuntime: PropTypes.shape({
    setTheme: PropTypes.func.isRequired,
    getTheme: PropTypes.func.isRequired,
    getThemeId: PropTypes.func.isRequired,
    clear: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node,
};


export function useStudioThemeRuntime() {
  const themeRuntime = useContext(
    StudioThemeContext
  );

  if (!themeRuntime) {
    throw new Error(
      "useStudioThemeRuntime must be used inside "
        + "StudioThemeProvider."
    );
  }

  return themeRuntime;
}


export function useStudioTheme() {
  const themeRuntime = useStudioThemeRuntime();

  const themeId = useSyncExternalStore(
    themeRuntime.subscribe,
    themeRuntime.getThemeId,
    themeRuntime.getThemeId
  );

  return Object.freeze({
    themeRuntime,
    themeId,
    theme: themeRuntime.getTheme(),
    setTheme: themeRuntime.setTheme,
    clearTheme: themeRuntime.clear,
  });
}


export default StudioThemeContext;
